var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 226,
    viewBox: "0 0 148 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.7567L71.7483 49.9766L74.0348 51.322L76.3191 49.9728L147.799 7.75295L143.222 0.00374699L74.0262 40.8744L4.56438 0L0 7.7567ZM0 27.1316L71.7483 69.3515L74.0348 70.6969L76.3191 69.3477L147.799 27.1279L143.222 19.3787L74.0262 60.2493L4.56438 19.3749L0 27.1316ZM71.7483 88.7264L0 46.5066L4.56438 38.7499L74.0262 79.6243L143.222 38.7536L147.799 46.5028L76.3191 88.7227L74.0348 90.0719L71.7483 88.7264ZM0 65.8815L71.7483 108.101L74.0348 109.447L76.3191 108.098L147.799 65.8778L143.222 58.1286L74.0262 98.9992L4.56438 58.1248L0 65.8815ZM71.7483 127.476L0 85.2564L4.56438 77.4997L74.0262 118.374L143.222 77.5035L147.799 85.2527L76.3191 127.473L74.0348 128.822L71.7483 127.476ZM0 104.631L71.7483 146.851L74.0348 148.197L76.3191 146.847L147.799 104.628L143.222 96.8784L74.0262 137.749L4.56438 96.8746L0 104.631ZM71.7483 166.226L0 124.006L4.56438 116.25L74.0262 157.124L143.222 116.253L147.799 124.003L76.3191 166.222L74.0348 167.572L71.7483 166.226ZM0 143.381L71.7483 185.601L74.0348 186.946L76.3191 185.597L147.799 143.377L143.222 135.628L74.0262 176.499L4.56438 135.624L0 143.381ZM71.7483 204.976L0 162.756L4.56438 154.999L74.0262 195.874L143.222 155.003L147.799 162.752L76.3191 204.972L74.0348 206.321L71.7483 204.976ZM0 182.131L71.7483 224.351L74.0348 225.696L76.3191 224.347L147.799 182.127L143.222 174.378L74.0262 215.249L4.56438 174.374L0 182.131Z",
    fill: "url(#paint0_linear_1_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 17.5557,
    y1: 158.756,
    x2: 74.1421,
    y2: 159.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7BE8",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMario);
export default __webpack_public_path__ + "static/media/mario.e41ed94c6df34febf3268e8598af4be1.svg";
export { ForwardRef as ReactComponent };